module.exports = __webpack_public_path__ + "static/img/bg.b0e6f3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.png
// module id = yEeP
// module chunks = 1